module.exports = __webpack_public_path__ + "img/d.a2db16ee.jpg";